<template>
  <Transition name="slide-down">
    <div v-if="store.currentView !== 'home'" ref="stepsRef" class="esim-steps-section">
      <Transition name="slide-left" mode="out-in">
        <PackagesView
          v-if="store.currentView === 'packages'"
          @back="store.HomeStep()"
          @select-package="handleSendPackage"
        />
        <RegisterView
          v-else-if="store.currentView === 'register'"
          @back="store.currentView = 'packages'"
          @back-home="store.HomeStep()"
          @checkout="handleCheckout"
        />
        <CheckoutView
          v-else-if="store.currentView === 'checkout'"
          @back="store.currentView = 'register'"
          @back-packages="store.currentView = 'packages'"
          @back-home="store.HomeStep()"
          @success="handleSuccess"
        />
        <ProfileView
          v-else-if="store.currentView === 'profile'"
          @back="store.HomeStep()"
        />
      </Transition>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { ref, watch, nextTick, onMounted, onUnmounted } from 'vue'
import { useStore } from '~/composables/widgetMode'
import PackagesView from '~/components/PackagesView.vue'
import RegisterView from '~/components/RegisterView.vue'
import CheckoutView from '~/components/CheckoutView.vue'
import ProfileView from '~/components/ProfileView.vue'
import type { PackageList } from '~/composables/types/esimPackage'

const store = useStore()
const stepsRef = ref<HTMLElement | null>(null)

const HIDE_STYLE_ID = 'esim-hide-section'

const hideSection = () => {
  const styleEl = document.getElementById(HIDE_STYLE_ID) as HTMLStyleElement | null
  if (styleEl) {
    styleEl.disabled = false
    return
  }
  const newStyle = document.createElement('style')
  newStyle.id = HIDE_STYLE_ID
  newStyle.innerHTML = `
    #search-container {
      display: none !important;
      visibility: hidden !important;
    }
  `
  document.head.append(newStyle)
}

const showSection = () => {
  const styleEl = document.getElementById(HIDE_STYLE_ID) as HTMLStyleElement | null
  if (styleEl) {
    styleEl.disabled = true
  }
}

const scrollToSteps = async () => {
  await nextTick()
  const el = stepsRef.value
  if (!el) return
  const top = el.getBoundingClientRect().top + window.scrollY - 80
  window.scrollTo({ top, behavior: 'smooth' })
}

watch(() => store.currentView, (view) => {
  if (view === 'home') {
    hideSection()
    return
  }
  showSection()
  scrollToSteps()
})

watch(() => store.countrySlug, () => {
  if (store.currentView !== 'packages') return
  scrollToSteps()
})

onMounted(() => {
  hideSection()
})

onUnmounted(() => {
  showSection()
})

const handleSendPackage = (pkg: PackageList, count: number) => {
  store.RegisterStep(pkg, count)
}

const handleCheckout = (pkg: PackageList, count: number, email: string) => {
  store.CheckoutStep(pkg, count, email)
}

const handleSuccess = (orderNo: string) => {
  store.ProfileStep(orderNo)
}
</script>

<style scoped>
.esim-steps-section {
  width: 100%;
  padding: 0.2rem;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.slide-left-enter-active,
.slide-left-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.slide-left-enter-from {
  opacity: 0;
  transform: translateX(20px);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>